// import {Print} from "@/fuckingJSExtension";

const axios = require('axios').default;

export function defaultCourses() {
    return {
        list: [],
        scheduleSlots: newCourseSlots(() => []),
        slotsFilled: newCourseSlots(() => false),
        listID: []
    }
}

function generateTimeSchedule(v) {
    if (v.time) {
        let splitInfo = v.time.split('-')
        v.rawTimeslot = splitInfo[0]
        if (splitInfo.length > 1) {
            v.location = splitInfo[1]
        }
        let ts = splitInfo[0]
        for (const num of "0123456789") {
            ts = ts.replace(num, '*' + num)
        }
        let splitTimeslot = ts.split('*')
        v.timeSchedules = []
        for (const ts of splitTimeslot) {
            let weekday = ts[0]
            for (const schedule of ts.substring(1)) {
                let t = weekday + schedule
                v.timeSchedules.push(t)
            }
        }
    } else {
        v.rawTimeslot = ''
        v.timeSchedules = []
    }
    return v;
}

export function courseAttrMapping(cf) {
    var cs = []
    for (const vo of cf) {
        let v = Object.assign(vo, {});
        let key = Object.keys(v)
        let shortenedKey = key.filter((k) => k.includes("cos_"))
        shortenedKey.forEach(function (k) {
            v[k.replace("cos_", "")] = v[k]
            delete v[k]
        })
        v = generateTimeSchedule(v);
        v.depType = {U: '大學部課程', D: '研究所課程'}[v.depType]
        v.credit = parseInt(v.credit) ? parseInt(v.credit) : 0
        v.desc = `[${v.type}]${v.cname} - ${v.teacher}:${v.dep_cname}`
        cs.push(v)
    }

    return cs
}

export function newEmptyCourse() {
    return {
        "TURL": "",
        "URL": null,
        "acy": "",
        "brief": "",
        "cos_cname": "",
        "cos_code": "",
        "cos_credit": "",
        "cos_ename": "",
        "cos_hours": "",
        "cos_id": "",
        "cos_time": "",
        "cos_type": "",
        "cos_type_e": "",
        "crsoutline_type": "",
        "degree": "",
        "depType": "",
        "dep_cname": "",
        "dep_ename": "",
        "dep_id": "",
        "dep_limit": "",
        "dep_primary": "",
        "memo": "",
        "num_limit": "",
        "reg_num": "",
        "sem": "",
        "teacher": ""
    }
}

export function newCourseSlots(generator) {
    const weekdays = '1234567'.split('')
    const time = 'MNABCDEXEFGHYIJKL'.split('')
    var courseSlots = {}
    for (const d of weekdays) {
        for (const t of time) {
            courseSlots[d + t] = generator()
        }
    }
    return courseSlots
}


//usage: getAllCourse.call(this);

export async function getAllCourse(me) {
    let _this = me


    if (_this.$localStorage.get('allCourses') && 0 !== 0) {
        let newAllCourses =
            _this.$localStorage.get('allCourses', {})
        console.log("Loaded courses", Object.keys(newAllCourses).length)
        console.log(newAllCourses)
        console.log("From local database")
        return newAllCourses
    } else {
        return await remoteGetCourses();
    }
}

export async function remoteGetCourses() {
    console.log("Fetch online timetable...")
    let timetableAPIURL = 'https://script.google.com/macros/s/AKfycbycThyD0_VpEpHACky9MCppOVIP33Pn1rV5NuFbqPZJRckmw0IG/exec'
    const resp = await axios.get(timetableAPIURL)
    // var newAllCourses = {};
    // var fetchList = []
    let json = resp.data
    console.log(' resp.data', json)
    // for (var key of Object.keys(json)) {
    //     let departureDetail = json[key]
    //     for (var fetch of [1, 2]) {
    //         if (departureDetail[fetch]) {
    //             fetchList = Object.values(departureDetail[fetch])
    //             let courses = courseAttrMapping(fetchList)
    //             for (let c of courses) {
    //                 newAllCourses[c.id] = c
    //             }
    //         }
    //     }
    // }
    for (let cid in json) {
        let c = json[cid]
        c = generateTimeSchedule(c)
        json[cid] = c
    }
    console.log("Loaded courses", Object.keys(json).length, json)
    return json
}

export function addCourse(courseGroup, course) {
    if (!course) return courseGroup;
    let courseAddedBefore = courseGroup.listID.includes(course.id)
    if (!courseAddedBefore) {
        courseGroup.list.push(course)
        courseGroup.listID.push(course.id)
        course.timeSchedules.forEach((t) => courseGroup.scheduleSlots[t].push(course))
        course.timeSchedules.forEach((t) => courseGroup.slotsFilled[t] = true)
    } else {
        console.log(courseGroup, course)
        let courseIndex = courseGroup.list.indexOf(course)
        courseGroup.list.splice(courseIndex, 1)
        let courseIDIndex = courseGroup.listID.indexOf(course.id)
        courseGroup.listID.splice(courseIDIndex, 1)
        for (let slot of course.timeSchedules) {
            courseGroup.scheduleSlots[slot].splice(course)
            if (courseGroup.scheduleSlots[slot].length === 0) {
                courseGroup.slotsFilled[slot] = false
            }
        }
    }
    return courseGroup
}

export function findDupNameCourses(courses) {
    // console.log(courses)
    var coursesNameEnum = {}
    const fuckingEnglish = []
    for (let c of courses) {
        var lang = c['授課語言代碼']
        var name = c.cname
        if(lang === 'en-us'){
            fuckingEnglish.push(c)
            continue
        }
        if(!coursesNameEnum[name]){
            coursesNameEnum[name] = []
        }
        coursesNameEnum[name].push(c)
    }

    for(const c of fuckingEnglish){
        for(const cname of Object.keys(coursesNameEnum)){
            if(c.cname.includes(cname)){
                coursesNameEnum[cname].push(c)
                break
            }
        }
    }

    var dupCourses = []

    var courseNameGroup = Object.values(coursesNameEnum)
    var nonUniqueCourse = courseNameGroup.filter((cs) => cs.length > 1)
    for(const cs of nonUniqueCourse){
        dupCourses = dupCourses.concat(cs)
    }
    var uniqueCourses = []
    var uniqueCourseRaw = courseNameGroup.filter((cs) => cs.length === 1)
    for(const cs of uniqueCourseRaw){
        uniqueCourses = uniqueCourses.concat(cs)
    }
    return {uniqueCourses, dupCourses}
}

export function findDepGroup(deps) {
    let depGroupType = {
        '在職專班': {cname: '在職專班', child: [], keyword: '專班'},
        '碩士班': {cname: '碩士班', child: [], keyword: '碩士'},
        '博士班': {cname: '博士班', child: [], keyword: '博士'},
        '研究所': {cname: '研究所', child: [], keyword: '研究所'},
        '跨域學程': {cname: '跨域學程', child: [], keyword: '跨域學程'},
        '學分學程': {cname: '學分學程', child: [], keyword: '學程'},
        '大學部': {cname: '大學部', child: [], keyword: '系'},
        '其他': {cname: '其他', child: [], keyword: ''},
    }
    for (let d of deps) {
        let depName = d.cname
        for (let dg in depGroupType) {
            // console.log(dg)
            let dgKeyword = depGroupType[dg].keyword
            if (depName.includes(dgKeyword)) {
                depGroupType[dg].child.push(d)
                break
            }
        }
    }
    return depGroupType
}

export function findDepEnum(courses) {
    // console.log(courses)
    let depNameEnum = {}
    for (let c of courses) {
        c.leaf = false
        let depName = c.dep_cname
        if (!depNameEnum[depName]) {
            depNameEnum[depName] = {'cname': depName, 'child': []}
        }
        depNameEnum[depName].child.push(c)
    }
    return depNameEnum
}

export function parseCourse(courseInput){
    courseInput += '\n0000'
    const courseLinePattern = /\d{4}.+?(?=\d{4})/gs;
    const courses = courseInput.matchAll(courseLinePattern)
    // Print(courses)
    const parsedCourse = {}
    for(let c of courses){
        // Print(c[0])
        // Print(c)
        let cp = c[0].replaceAll('\t',' | ').replace('\n','')
        // Print(cp)
        const attributes = cp.split(' | ')
        let attrName = '當期課號 | 開課單位 | 備註 | 課名 | 人上限 | 已登記 | 志願1 | 志願2 | 志願3 | 志願4 | 志願5 | 時間地點 | 學分 | 時數 | 老師 | 類別 | 備註'.split(' | ')
        let courseAttr = {}
        for(let attrIndex of Array(attributes.length).keys()){
            courseAttr[attrName[attrIndex]] = attributes[attrIndex]
        }
        if(courseAttr['人上限'] === '不限' ) courseAttr['人上限'] = 9999;
        courseAttr['剩餘空位'] = parseInt(courseAttr['人上限']) - parseInt(courseAttr['已登記'])
        courseAttr['第一志願機率'] = Math.round(courseAttr['剩餘空位'] * 100 / (parseInt(courseAttr['志願1']) + 1))
        parsedCourse[attributes[0]] = courseAttr
    }
    // Print(parsedCourse)
    return parsedCourse
}
